import Cookies from 'js-cookie'
import { reactive } from 'vue'
import store from '@/store/index'
import { getRefreshToken } from '@/services/auth/authToken.service'
import env from '@/services/environment'
import { LogOutService } from '@/services/auth/common/logOutService'

export const TokenInfoService = reactive({
  tokenData () {
    const token = JSON.parse(sessionStorage.getItem('accessInfo')) || store.getters['token/TokenInfo'] || this.checkBrowserCookies()
    if (token) {
      return {
        accessToken: token?.accessToken,
        refreshToken: token?.refreshToken
      }
    } else {
      return null
    }
  },

  checkBrowserCookies () {
    const accessTokenCookies = Cookies.get(env.getEnvVariable('VUE_APP_SSO_ACCESS_TOKEN'))
    const refreshTokenCookies = Cookies.get(env.getEnvVariable('VUE_APP_SSO_REFRESH_TOKEN'))
    if (accessTokenCookies && refreshTokenCookies) {
      return {
        accessToken: accessTokenCookies,
        refreshToken: refreshTokenCookies
      }
    } else {
      return null
    }
  },

  clearBrowserCookies () {
    Cookies.set(env.getEnvVariable('VUE_APP_SSO_ACCESS_TOKEN'), '')
    Cookies.set(env.getEnvVariable('VUE_APP_SSO_REFRESH_TOKEN'), '')
  },

  updateAccessToken (token) {
    console.log('updatedAccessToken received')
    store.dispatch('token/setTokenInfo', token)
    sessionStorage.setItem('accessInfo', JSON.stringify(token))
    this.buildExpirationDate()
  },

  buildExpirationDate () {
    const token = this.tokenData()
    if (!token) {
      console.warn('Unable to set expiration date due to empty access_token')
      return null
    }

    const jsonToken = this.decodeJwt(token?.accessToken)
    const setTokenExpiration = new Date(jsonToken.exp * 1000)
    console.log('token expiration time--- ', setTokenExpiration)
    store.dispatch('UsersAccess/setUserTokenExpiration', setTokenExpiration)
    this.handleActionUserActive(setTokenExpiration)
  },

  decodeJwt (token) {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    return JSON.parse(window.atob(base64))
  },

  handleActionUserActive (tokenExpiration) {
    const currentDateTime = new Date()
    let timeExpired = tokenExpiration.getTime() - currentDateTime.getTime()
    // Setting expiration time one mintue early
    timeExpired = timeExpired - 60000
    console.log(timeExpired)
    if (timeExpired) {
      const tokenInterval = setInterval(() => {
        const tokenData = TokenInfoService.tokenData()
        store.dispatch('ui/showMask')
        getRefreshToken(tokenData?.refreshToken).then((response) => {
          if (response.status === 200) {
            store.dispatch('ui/hideMask')
            const token = response.content
            const accessInfo = {
              accessToken: token.idToken,
              refreshToken: token?.refreshToken
            }
            console.log('refresh accessInfo received- ')
            clearInterval(tokenInterval)
            this.updateAccessToken(accessInfo)
            store.dispatch('ui/hideMask')
          }
        }).catch(error => {
          console.log(error)
          store.dispatch('ui/hideMask')
          LogOutService.logoutApp()
        })
      }, timeExpired)
    }
  }
})
